import { defineCommands, type CommandsOf, applyEntityDataChanges } from '../../commands/defineCommands';
import type { CanvasStoreContext } from '../../types';
import type { BlockNodeData } from '../../entityTypes';

export const blocknodeCommands = defineCommands({
  'blocknode.updateData': (ctx: CanvasStoreContext, event: {
    entityId: string; dataChanges: Partial<BlockNodeData>;
  }): CanvasStoreContext => applyEntityDataChanges(ctx, event.entityId, event.dataChanges),
});

export type BlocknodeCommand = CommandsOf<typeof blocknodeCommands>;
